export const defaultGapBetweenSlidesInPercentage = 2